import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CoreScoreNames } from "../../../enum/score-name-cube.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryAverageScoresRequestParamsDto {
    startDate: string;
    endDate: string;
    timezone?: string;
    granularity?: CubeTimeDimensionGranularity;
    score?: CoreScoreNames;
}